//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    filter: {
      type: Array,
      default: () => {
        return []
      }
    },
    filterPrice: {
      type: Object,
      default: () => {
        return {}
      }
    },
    selectedFilters: {
      type: Object,
      default: () => {
        return {}
      }
    },

    isMobile: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    items: function () {
      let items = [];
      Object.keys(this.selectedFilters || {}).map((key) => {
        const value = this.selectedFilters?.[key];
        const filter = this.filter.find((t) => t.slug === key);
        const filterSlug = filter?.slug || "";
        const filterName = filter?.nameForFilter || filter?.name || "";
        const variants = filter?.variants || [];

        if (['priceTo', 'priceFrom'].includes(key)) {
          const _valuePrice = Object.keys(value || {})?.[0];
          items.push({
            filterName: 'Цена',
            filterSlug: key,
            variantSlug: _valuePrice,
            variantLabel: `${Boolean(key === 'priceTo') ? 'До': 'От'} ${ _valuePrice } ₽`,
          });
        } else {
          Object.keys((value || {})).map((_key) => {
            const variant = variants.find((t) => t.slug === _key);
            items.push({
              filterSlug,
              filterName: filterName,
              variantSlug: variant?.slug,
              variantLabel: variant?.label,
            });
          });
        }
      });
      return items
    },
  },

  methods: {
    resetAllFilter: function () {
      this.$emit("update", {});
    },

    removeVariantSlug: function (item) {
      let selectedFilters = {...this.selectedFilters};
      delete selectedFilters[item.filterSlug][item.variantSlug];
      if (Object.keys(selectedFilters[item.filterSlug] || {}).length <= 0) {
        delete selectedFilters[item.filterSlug];
      }
      this.$emit("update", selectedFilters);
    },
  }
}
